/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_cancle': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<defs><path pid="0" d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" id="svgicon_icon_cancle_a"/></defs><g transform="translate(-2 -2)" _fill="none" fill-rule="evenodd"><mask id="svgicon_icon_cancle_b" _fill="#fff"><use xlink:href="#svgicon_icon_cancle_a"/></mask><g mask="url(#svgicon_icon_cancle_b)" _fill="#898D94"><path pid="1" d="M0 0h24v24H0z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_cancle.js